import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import type { FCWithChildren } from "../@types";
import { routes } from "../app/routes";
import { getUrlFragment } from "../helpers/urlHelpers";

export const ScrollRestoration: FCWithChildren = ({ children }) => {
  // * Location
  const { pathname } = useLocation();

  // * Refs
  const previousPathnameRef = useRef(pathname);

  /** Skip for any routes that rerender all content on changes to the `page`
   * query param (Enrollment is the only example as of the time this was written) */
  const queryParamPageRoutes = [routes.enroll] as string[];
  const queryParamRoutedPage = queryParamPageRoutes.includes(pathname);

  // For "normal" routes, watch changes to pathname and scroll to top
  useEffect(() => {
    if (queryParamRoutedPage || previousPathnameRef.current === pathname) {
      return;
    }
    /** If we have a url hash fragment, we should not scroll to top of the page. We want to show the user the section indicated by the fragment. Currently used on our Plan Details page, for example. */
    if (!getUrlFragment()) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
    previousPathnameRef.current = pathname;
  }, [pathname, queryParamRoutedPage]);

  return <>{children}</>;
};
